"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _constants = require("./constants");

var _typography = _interopRequireDefault(require("../typography"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function () {
  var styles = "@font-face {\n  font-family: 'OpenSansRegular';\n  src: url(\"../assets/font/OpenSans-latin-normal.woff2\") format(\"woff2\"); }\n\n.bds-loader-overlay {\n  position: fixed;\n  z-index: 6000;\n  top: 0;\n  left: 0;\n  display: flex;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n  background-color: #ffffff;\n  opacity: 0.8; }\n\n.bds-loader-overlay-on-container {\n  position: absolute; }\n\n.bds-loader-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  width: fit-content; }\n  .bds-loader-container p {\n    margin-top: 0.5rem; }\n\n.bds-loader {\n  border: 0.3125rem solid #e5e5e5;\n  border-radius: 50%;\n  border-top: 0.3125rem solid #0561a7;\n  -webkit-animation: spin 1s linear infinite;\n  /* Safari */\n  animation: spin 1s linear infinite; }\n\n.bds-loader-small {\n  width: 0.625rem;\n  height: 0.625rem;\n  border-width: 0.1875rem;\n  border-top-width: 0.1875rem; }\n\n.bds-loader-medium {\n  width: 2.875rem;\n  height: 2.875rem; }\n\n.bds-loader-large {\n  width: 7.875rem;\n  height: 7.875rem; }\n\n/* Safari */\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg); } }\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n";
  var fileName = "compone_spinner";
  var element = document.querySelector("style[data-sass-component='compone_spinner']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var Loader = function Loader(_ref) {
  var _loaderClasses;

  var size = _ref.size,
      message = _ref.message;
  var loaderClasses = (_loaderClasses = {}, _defineProperty(_loaderClasses, _constants.classes.loader, true), _defineProperty(_loaderClasses, _constants.classes.smallLoader, size === _constants.spinnerSize.small), _defineProperty(_loaderClasses, _constants.classes.mediumLoader, size === _constants.spinnerSize.medium), _defineProperty(_loaderClasses, _constants.classes.largeLoader, size === _constants.spinnerSize.large), _loaderClasses);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.loaderContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": _constants.classes.loader,
    className: (0, _classnames.default)(loaderClasses)
  }), message && /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "body"
  }, message));
};

var LoaderWithOverlay = function LoaderWithOverlay(_ref2) {
  var _overlayClasses;

  var size = _ref2.size,
      message = _ref2.message,
      overlayOnContainer = _ref2.overlayOnContainer;
  var overlayClasses = (_overlayClasses = {}, _defineProperty(_overlayClasses, _constants.classes.loaderOverlay, true), _defineProperty(_overlayClasses, _constants.classes.loaderOverlayOnContainer, overlayOnContainer), _overlayClasses);
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": _constants.classes.loaderOverlay,
    className: (0, _classnames.default)(_objectSpread({}, overlayClasses))
  }, /*#__PURE__*/_react.default.createElement(Loader, {
    size: size,
    message: message
  }));
};

var Spinner = function Spinner(_ref3) {
  var _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? _constants.spinnerSize.large : _ref3$size,
      overlay = _ref3.overlay,
      message = _ref3.message,
      overlayOnContainer = _ref3.overlayOnContainer;
  return !overlay && !overlayOnContainer ? /*#__PURE__*/_react.default.createElement(Loader, {
    size: size,
    message: message
  }) : /*#__PURE__*/_react.default.createElement(LoaderWithOverlay, {
    size: size,
    message: message,
    overlayOnContainer: overlayOnContainer
  });
};

Spinner.propTypes = {
  message: _propTypes.default.string,
  size: _propTypes.default.oneOf([_constants.spinnerSize.small, _constants.spinnerSize.medium, _constants.spinnerSize.large]),
  overlay: _propTypes.default.bool,
  overlayOnContainer: _propTypes.default.bool
};
var _default = Spinner;
exports.default = _default;